import classNames from "classnames";
import React from "react";
import styles from "./Notification.module.css";

export const Notification = ({ children, error }) => {
  return <div className={classNames(styles.notification, { [styles.notificationError]: error })}>{children}</div>;
};
